import { forwardRef, type Ref, type SVGProps } from "react";
const IconShovelOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.5 13.857c.557.001 1.103.16 1.573.458a2.95 2.95 0 0 1 1.427 2.503v5.929a5.07 5.07 0 0 1-2.108 3.895l-4.172 2.745a4.32 4.32 0 0 1-4.439 0L9.61 26.642a5.07 5.07 0 0 1-2.11-3.895V16.82a2.95 2.95 0 0 1 1.425-2.505 2.95 2.95 0 0 1 1.573-.458h1.716l-.717-7.408C11.497 3.992 13.513 2 16 2s4.5 1.992 4.5 4.45l-.716 7.407zm-3-7.483c-.048-1.333-1.152-2.39-2.502-2.396-1.348.007-2.45 1.064-2.499 2.396l.724 7.484h3.554zm3.998 16.373a3.18 3.18 0 0 1-1.219 2.256l-4.172 2.745a2.28 2.28 0 0 1-2.219 0l-4.172-2.745a3.18 3.18 0 0 1-1.22-2.256v-5.93c.007-.543.45-.981 1-.988H15v4.94a.994.994 0 0 0 1 .96.994.994 0 0 0 1-.96v-4.937h4.5c.549.006.992.444 1 .986zM16 7.477a.795.795 0 0 1-.8-.79c0-.438.358-.792.8-.792s.8.354.8.791-.358.79-.8.79"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShovelOutlineSVG);
ForwardRef.displayName = "IconShovelOutline";
export { ForwardRef as IconShovelOutline };
